<template>
  <div>
    <el-row>
      <el-col :span="20" :offset="2">
        <div class="dw-user-body">
          <el-row>
            <el-col :span="4" style="height: 600px;">
              <dw-user-menu></dw-user-menu>
            </el-col>
            <el-col :span="20">
              <div style="padding: 30px;width: 400px;">
                <el-form ref="ruleForm" :model="ruleForm" :rules="rules" status-icon label-width="80px" label-position="left">

                  <el-form-item v-if="userInfo.cellphone !=null && userInfo.cellphone!==undefined && userInfo.cellphone!==''" label="原手机号" prop="cellphone">
                    <el-input v-model="userInfo.cellphone" autocomplete="off" readonly disabled ></el-input>
                  </el-form-item>
                  <el-form-item v-if="userInfo.cellphone !=null && userInfo.cellphone!==undefined && userInfo.cellphone!==''" label="原验证码" prop="oldCheckCode">
                    <el-row :gutter="0">
                      <el-col :span="10">
                        <el-input v-model="ruleForm.oldCheckCode" autocomplete="off" ></el-input>
                      </el-col>
                      <el-col :span="14" style="padding-left: 10px;">
                        <el-button :disabled="btnDisabled1" style="" @click="sentLoginSmsCode(1)">{{ buttonText1 }}</el-button>
                      </el-col>
                    </el-row>
                  </el-form-item>
                  <el-form-item label="新手机号" prop="newPhone">
                    <el-input v-model="ruleForm.newPhone" autocomplete="off" ></el-input>
                  </el-form-item>
                  <el-form-item label="原验证码" prop="newCheckCode">
                    <el-row :gutter="0">
                      <el-col :span="10">
                        <el-input v-model="ruleForm.newCheckCode" autocomplete="off" ></el-input>
                      </el-col>
                      <el-col :span="14" style="padding-left: 10px;" >
                        <el-button :disabled="btnDisabled2" style="" @click="sentLoginSmsCode(2)">{{ buttonText2 }}</el-button>
                      </el-col>
                    </el-row>
                  </el-form-item>
                  <el-form-item style="padding-top: 20px;">
                    <el-button type="primary" @click="submitForm('ruleForm')">提交修改</el-button>
                    <el-button @click="resetForm('ruleForm')">重置</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import DwUserMenu from './DwUserMenu'
import {dwUserBindPhone, dwUserInfo} from '../../api/dw-user'
import {sendFakeCaptcha} from '../../api/dw-login'
import {msgError, msgSuccess} from '../../utils/dw-msg'

export default {
  name: 'DwUserPwd',
  components: {
    DwUserMenu
  },
  data () {
    return {
      userInfo: {},
      btnDisabled1: false,
      btnDisabled2: false,
      buttonText1: '获取验证码',
      buttonText2: '获取验证码',
      countdownNum: 0,
      countdownInterval: null,
      ruleForm: {
        cellphone: '',
        oldCheckCode: '',
        newPhone: '',
        newCheckCode: ''
      },
      rules: {
        oldCheckCode: [
          {required: true, message: '请输入原手机机验证码', trigger: 'blur'},
          {min: 6, max: 6, message: '验证码长度为 6 个字符', trigger: 'blur'}
        ],
        newPhone: [
          {required: true, message: '请输入新手机号', trigger: 'blur'}
        ],
        newCheckCode: [
          {required: true, message: '请输入新手机机验证码', trigger: 'blur'},
          {min: 6, max: 6, message: '验证码长度为 6 个字符', trigger: 'blur'}
        ]
      }
    }
  },
  mounted () {
    this.getUserInfo()
  },
  methods: {
    getUserInfo () {
      dwUserInfo().then((response) => {
        const resultData = response.data.data
        this.userInfo = resultData
        this.ruleForm.cellphone = resultData.cellphone
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = this.ruleForm
          dwUserBindPhone(params).then((response) => {
            const httpResult = response.data
            if (httpResult.resultCode === 200) {
              this.$message.success('新手机号绑定成功')
              this.$router.push('/dw/user')
            } else {
              this.$message.error('新手机号绑定失败')
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    sentLoginSmsCode (type) {
      const params = {phone: '', eventType: null}
      if (type === 1) {
        // 原手机号
        params.phone = this.userInfo.cellphone
        params.eventType = 5
      } else if (type === 2) {
        // 新手机号
        params.phone = this.ruleForm.newPhone
        params.eventType = 3
      }
      const phone = params.phone
      if (phone!==null && phone!==undefined && phone!=='') {
        if (type === 1) this.buttonText1 = '发送中...'
        if (type === 2) this.buttonText2 = '发送中...'
        sendFakeCaptcha(params).then((response) => {
          const httpResult = response.data
          if (httpResult.resultCode === 200) {
            msgSuccess('发送成功，请注意查看手机短信！')
            this.beginCountdown(type)
            if (type === 1) this.ruleForm.oldCheckCode = httpResult.data
            if (type === 2) this.ruleForm.newCheckCode = httpResult.data
          } else {
            msgError('发送失败，请确认！')
            if (type === 1) this.buttonText1 = '重新获取验证码'
            if (type === 2) this.buttonText2 = '重新获取验证码'
          }
        })
      } else {
        console.log('error submit!!')
        msgError('请输入对应手机号！')
        return false
      }
    },
    beginCountdown (type) {
      this.countdownNum = 0
      if (type === 1) this.btnDisabled1 = true
      if (type === 2) this.btnDisabled2 = true
      if (this.countdownInterval === null) {
        this.countdownInterval = setInterval(() => {
          this.countdownFn(60, type)
        }, 1000)
      }
    },
    countdownFn (countVal, type) {
      if (this.countdownNum >= countVal) {
        if (this.countdownInterval !== null) {
          clearInterval(this.countdownInterval)
          this.countdownInterval = null
          if (type === 1) this.buttonText1 = `获取验证码`
          if (type === 2) this.buttonText2 = `获取验证码`
          if (type === 1) this.btnDisabled1 = false
          if (type === 2) this.btnDisabled2 = false
        }
      } else {
        this.countdownNum = this.countdownNum+1
        const btnTxtNum = countVal-this.countdownNum
        if (type === 1) this.buttonText1 = `${btnTxtNum} 后重新获取`
        if (type === 2) this.buttonText2 = `${btnTxtNum} 后重新获取`
      }
    }
  }
}
</script>

<style scoped>
.dw-user-body{
  background-color: white;
  min-height: 600px;
}
</style>



// WEBPACK FOOTER //
// src/views/dw-user/DwUserBindPhone.vue